module.exports = __webpack_public_path__ + "static/snake_albedo-856ecfd2b7e4ea9da2df9dac826b16af.png";